import React from 'react';
import './Register.css';

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
    };
  }

  onNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  onEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  onPasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  onSubmitSignIn = (attemptNum = 1) => {
    fetch('https://smart--brain-app.herokuapp.com/register', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        password: this.state.password,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          const delay = 1000;
          second;
          setTimeout(() => {
            this.onSubmitSignIn(attemptNum + 1);
          }, delay);
          throw new Error(`Response not ok (attempt ${attemptNum}).`);
        }
        return response.json();
      })
      .then((user) => {
        if (user.id) {
          this.props.loadUser(user);
          this.props.onRouteChange('home');
        }
      })
      .catch((error) => {
        const delay = 1000;
        second;
        if (attemptNum <= 5) {
          setTimeout(() => {
            this.onSubmitSignIn(attemptNum + 1);
          }, delay);
        } else {
          console.error(`Maximum number of retries reached: ${error}`);
        }
      });
  };

  render() {
    const { onRouteChange } = this.props;

    return (
      <article
        className='br3 ba --black-10 mv4 w-100 w-50-m w-25-l mw6 center shadow-5'
        id='main__register'
      >
        <main className='pa4 black-80'>
          <div className='measure'>
            <fieldset id='sign_up' className='ba b--transparent ph0 mh0'>
              <legend className='f1 fw6 ph0 mh0'>Register</legend>
              <div className='mt3'>
                <label className='db fw6 lh-copy f6' htmlFor='name'>
                  Name
                </label>
                <input
                  onChange={this.onNameChange}
                  className='pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100'
                  type='text'
                  name='name'
                  id='name'
                />
              </div>
              <div className='mt3'>
                <label className='db fw6 lh-copy f6' htmlFor='email-address'>
                  Email
                </label>
                <input
                  onChange={this.onEmailChange}
                  className='pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100'
                  type='email'
                  name='email-address'
                  id='email-address'
                />
              </div>
              <div className='mv3'>
                <label className='db fw6 lh-copy f6' htmlFor='password'>
                  Password
                </label>
                <input
                  onChange={this.onPasswordChange}
                  className='b pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100'
                  type='password'
                  name='password'
                  id='password'
                />
              </div>
            </fieldset>
            <div className=''>
              <input
                onClick={this.onSubmitSignIn}
                className='b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib'
                type='submit'
                value='Register'
              />
            </div>
            <div className='lh-copy mt3'>
              <p
                onClick={() => onRouteChange('signIn')}
                className='f6 link dim black db pointer'
              >
                Go Back
              </p>
            </div>
          </div>
        </main>
      </article>
    );
  }
}

export default Register;
